import PurchasesEvent from './Index.vue';

export default PurchasesEvent;



// WEBPACK FOOTER //
// ./src/pages/profile/views/purchases/pages/purchases-event/index.ts